import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { NodeSelection } from '@tiptap/pm/state';
import { renderLatexToHtml } from '../services/latexRenderer';
import MathNodeView from '../components/MathNodeView';

export const MathExtension = Node.create({
  name: 'math',
  group: 'inline',
  inline: true,
  atom: true,
  marks: '_',

  addAttributes() {
    return {
      latex: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-latex') || element.textContent || '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="math"]',
        getAttrs: (element) => ({
          latex: element.getAttribute('data-latex') || element.textContent || '',
        }),
      },
      {
        tag: 'span.math-formula-container',
        getAttrs: (element) => ({
          latex: element.getAttribute('data-latex') || element.textContent || '',
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    const latex = HTMLAttributes.latex || '';
    // خروجی استاتیک (برای دیتابیس/PDF): فرمول از قبل با KaTeX رندر (با اعداد فارسی) ذخیره می‌شود
    const rendered = renderLatexToHtml(latex);

    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        'data-type': 'math',
        'data-latex': latex,
        class: 'math-formula-container',
        style: 'display: inline-block; direction: ltr; unicode-bidi: isolate; vertical-align: middle; margin: 0 4px;',
      }),
      ['span', { class: 'katex-rendered-content' }, rendered],
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(MathNodeView);
  },

  addCommands() {
    return {
      insertMath:
        (latex) =>
        ({ chain }) => {
          return chain()
            .insertContent([
              { type: this.name, attrs: { latex } },
              { type: 'text', text: ' ' },
            ])
            .run();
        },

      updateMath:
        (latex) =>
        ({ commands }) => {
          return commands.updateAttributes(this.name, { latex });
        },
    };
  },
});
